<app-hero />
<app-problem />
<app-formats />
<app-quiz-prep />
<app-steps />
<app-no-app />
<app-trust />
<app-dj-control />
<app-testimonials />
<app-faq />
<app-contact-section />
<app-cta />
